export default __webpack_public_path__ + "static/learn-poster-d4b1628b4e6a39cc99908609b65d1499.jpg";